export const WsTriggers = {
    ADMIN: 'admin',
    COMPANIES: 'companies',
    HISTORY: 'history',
    SELECTED_COMPANY: 'selectedCompany',
    SELECTED_SUPPLIER: 'selectedSupplier',
    TASK: 'task',
    CALC: 'calc',
    TTN: 'ttn',
    GROUPS: 'groups',
};
